import React, {PropTypes} from 'react';


function CandidateIcon(props) {
  const {
    className,
    ...otherProps
  } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 20 21" className={`candidate-icon ${className}`} {...otherProps}>
        <g fill="none" fillRule="evenodd" stroke="#FFF" strokeWidth="2">
            <path d="M4.51 9.328C5.49 10.35 6.913 11 8.5 11c1.587 0 3.01-.649 3.99-1.672.848-.884 1.367-2.048 1.367-3.328 0-2.761-2.398-5-5.357-5S3.143 3.239 3.143 6c0 1.28.52 2.444 1.367 3.328z"/>
            <path d="M4.641 9C2.575 10.27 1 12.66 1 15.176V20h15v-4.824c0-2.515-1.575-4.905-3.641-6.176"/>
        </g>
    </svg>
  );
}


CandidateIcon.propTypes = {
  className: PropTypes.string
};

export default CandidateIcon;



// WEBPACK FOOTER //
// ./shared/common/svgs/CandidateIcon/index.js